import { render, staticRenderFns } from "./ManualModal.vue?vue&type=template&id=47c203cb&scoped=true"
import script from "./ManualModal.vue?vue&type=script&lang=js"
export * from "./ManualModal.vue?vue&type=script&lang=js"
import style0 from "./ManualModal.vue?vue&type=style&index=0&id=47c203cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c203cb",
  null
  
)

export default component.exports